// Visual mapping for Capacity statuses. All colours route through tokens.
import { T } from "../../app/tokens.js";
import { FIT_STYLE } from "../../services/seatFit.js";

export const CAPACITY_CELL = {
  ...FIT_STYLE,
  partial: { bg: T.card, border: T.border },
  no_seats: { bg: T.card, border: T.border },
  excluded: { bg: T.card, border: T.border },
  no_data: { bg: T.card, border: T.border },
  history: { bg: T.card, border: T.borderDark, dashed: true },
};

export const SEAT_STYLE = {
  used: { background: `color-mix(in srgb, ${T.dark} 12%, ${T.card})`, border: `1px solid ${T.borderDark}` },
  spare: { background: T.lightGray, border: `1px solid ${T.border}` },
  densUsed: { background: T.tealSoftBg, border: `1px solid ${T.ragAmberBorder}` },
  densRoom: { background: T.tealSoftBg, border: `1px solid ${T.ragAmberBorder}` },
  over: { background: CAPACITY_CELL.over.bg, border: `1px solid ${CAPACITY_CELL.over.border}` },
};

// Matches the report's inline VerdictPill / DensityPill; no report edits.
export function statusPillStyle(status) {
  const st = CAPACITY_CELL[status] ?? CAPACITY_CELL.no_data;
  return { display: "inline-flex", alignItems: "center", fontSize: T.fsXs,
    fontWeight: T.fwSemibold, padding: "2px 10px", borderRadius: 6,
    whiteSpace: "nowrap", background: st.bg, color: st.ink ?? T.mid };
}

export const INK = T.dark;

export function cellStyleFor(evalResult) {
  if (!evalResult) return CAPACITY_CELL.no_data;
  return CAPACITY_CELL[evalResult.status] ?? CAPACITY_CELL.no_data;
}

export const TONE_COLOR = { good: T.greenDeep, bad: T.ragRed, flat: T.light };

// Maximum square geometry; the collection grid shrinks to available width.
export const CELL_SIZE = { monthly: 20, quarterly: 36 };
export const PERIOD_GAP = { monthly: 6, quarterly: 8 };
export const ROW_HEIGHT = { default: 44, compact: 30 };
export const SEAT_SIZE = 10;
export const SEAT_GAP = 3;
// The drawer's small wrapping strip retains its existing geometry.
export const CELL_GAP = 3;
export const CELL_RADIUS = 3;
export const CHANGED_OUTLINE = 1.5;
export const LONG_RANGE_OPACITY = 0.45;
